module.exports = __webpack_public_path__ + "img/pipetting.aedcf758.png";